import { render, staticRenderFns } from "./carService.vue?vue&type=template&id=f8b37998&scoped=true&"
import script from "./carService.vue?vue&type=script&lang=js&"
export * from "./carService.vue?vue&type=script&lang=js&"
import style0 from "./carService.vue?vue&type=style&index=0&id=f8b37998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b37998",
  null
  
)

export default component.exports